import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import Patients from "../../modules/Patients";
import { Tooltip } from "@mui/material";
import { BiEditAlt } from "react-icons/bi";
import EditPatientJobDialog from "../../components/Dialogs/EditPatientJobDialog";
import { Button, Col, Form, Row } from "react-bootstrap";
import { DatePicker, Select, Space } from "antd";
import { Option } from "antd/lib/mentions";
import CustomButtons from "./../ui-elements/Buttons/CustomButtons";
import moment from "moment";
// import 'moment-timezone';
import { Modal } from "react-bootstrap";
import Skelton from "../../components/Skelton/Skelton";
import { AiOutlineDown } from "react-icons/ai";
import { AiOutlineDownload } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";
import CustomTextFilterComponent from "./CustomTextFilterComponent";
import PDFViewer from "./PDFviewer";
import LdcApi from "../../LdcApis";
import { Spin } from "antd";
import { GrView } from "react-icons/gr";
import dayjs from "dayjs";
import { FaImages } from "react-icons/fa";
const userInfo = JSON.parse(localStorage.getItem("user_info"));

function PatientJobTable({
  assignedData,
  jobListData,
  getJobDetailsPatient,
  categoryListStatus,
  getCaegoryListStatus,
  roleListStatus,
  getRoleListStatus,
  loading1,
  loading2,
  loading3,
}) {
  const gridRef = useRef();
  const [statusSelect, setStatusSelect] = useState("Open");
  const dateFormat = "DD-MM-YYYY";
  const { RangePicker } = DatePicker;
  const [showEditJobPatient, setShowEditJobPatient] = useState(false);
  const [editJobData, setEditJobData] = useState({});
  const [selectCategory, setCategory] = useState("");
  const [roleSelect, setRoleSelect] = useState("");
  const [selectAllBtn, setSelectAllBtn] = useState(true);
  // const [jobListData, setJobListData] = useState([]); // Default to empty array
  const [rowData, setRowData] = useState(jobListData);
  const [imagePopUp, setImagePopUp] = useState(false);
  const [imageLink, setImageLink] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [buttonDetails, setButtonDetails] = useState(null);
  const [firstSelectField, setFirstSelectField] = useState("");
  const [currentClkButton, setCurrentClkBtn] = useState("");
  const [loadingForDelete, setLoadingForDelete] = useState(false);
  const [currentObj, setCurrentObj] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfView, setPdfView] = useState("");
  const [viewPDFModal, setViewPDFModal] = useState(false);
  const viewOnly =
    userInfo.roleName.replace(/\s/g, "").toUpperCase() === "VIEWONLY";

  const prevObj = null;
  // useEffect(() => {
  //   if (categoryListStatus.length > 0 && roleListStatus.length > 0) {
  //     const obj = {};
  //     categoryListStatus.forEach((item) => {
  //       obj[item.category] = 0;
  //     })
  //     roleListStatus.forEach((item) => {
  //       obj[item.doctorId] = 0;
  //     })
  //     obj["All"]=0;
  //     setButtonDetails({ ...obj });
  //   }
  // }, [categoryListStatus, roleListStatus])
  useEffect(() => {
    switch (userInfo.roleName) {
      case "Administration":
        setRoleSelect("Admin");
        break;
      case "Booking Team":
        setRoleSelect("Booking Team");
        break;
      case "Clinic Assistant":
        setRoleSelect("Clinic Team");
        break;
      case "Manager":
        setRoleSelect("Manager");
        break;
      case "Doctors":
        setRoleSelect("Doctor");
        break;
      default:
        if (userInfo.userType === "D") {
          setRoleSelect("Doctor");
          break;
        } else {
          setRoleSelect("");
        }
    }
  }, [userInfo]);

  useEffect(() => {}, [buttonDetails]);
  function formatDateToYYYYMMDD(date) {
    // Get the current date and time in the UK time zone
    // Ensure the parameter is a Date object; if not, use the current date
    const now = moment().tz("Europe/London");
    const currentDate = date instanceof Date ? date : new Date();
    // Extract year, month, and day
    // Calculate 1 month ago from the current date
    const year = currentDate.getFullYear();
    const threeMonthsAgo = now.clone().subtract(3, "months");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const day = currentDate.getDate().toString().padStart(2, "0");
    // Format the date
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  const now = new Date();
  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

  const defaultValue = [
    dayjs(formatDateToYYYYMMDD(threeMonthsAgo)),
    dayjs(formatDateToYYYYMMDD(now)),
  ]; // RangePicker takes an array of two moment objects

  // // State to hold the selected date range
  const [selectedRange, setSelectedRange] = useState(defaultValue);

  // // Event handler for date range change
  const handleDateChange = (dates) => {
    setSelectedRange(dates);
  };

  const ViewAttachment = (params) => {
    setViewPDFModal(true);
    setPdfView(params);
  };
  const closePDFView = () => {
    setViewPDFModal(false);
  };

  const handleChange = (value) => {
    setStatusSelect(value);

    // const newData = jobListData.filter((e) => e.status === value);
    // setRowData(newData);
  };
  const viewBtnClick = (src) => {
    setViewPDFModal(true);
    setImageLink(src);
  };

  const openModalForTestReading = (fieldName, patient, obj) => {
    setShowPopUp(true);
    if (fieldName === "Outcome" && obj) {
      const [date, time] = obj.createdOn.split("T");
      const [year, month, day] = date.split("-");
      const formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
      const formattedTime = time.slice(0, 5);
      setCurrentMessage({
        fieldName: `${fieldName} :: ${patient}`,
      });
      setCurrentObj({
        cUser: obj.cUser,
        formattedDate,
        formattedTime,
        outcomes: obj.outComes,
        getJobListOutCome: obj.getJobListOutCome,
      });
    } else {
      setCurrentMessage({
        fieldName: `${fieldName} :: ${patient}`,
        text: obj,
      });
    }
  };

  const [columnDefs] = useState([
    {
      headerName: " Patient Name",
      field: "patientName",
      width: 140,
      maxWidth: 140,
      filter: true,
      // filterFramework: CustomTextFilterComponent,
      cellRenderer: function (params) {
        return (
          <div
            className="d-flex align-items-center actions_ag_grid"
            style={{
              textTransform: "capitalize",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() =>
              window.open(`/profile/${params.data.patientId}`, "_blank")
            }
          >
            {params.value} :: {params.data.patientId}
          </div>
        );
      },
    },
    {
      headerName: "Task Details",
      field: "jobDetails",
      width: 290,
      maxWidth: 290,
      cellClass: "jobdetailsClass",
      filter: true,
      // cellRendererFramework:ShowingText,
      cellRenderer: function (params) {
        const words = params.value.split(" ");
        const maxWordsToShow = 10;
        return (
          <div
            className="d-flex align-items-center actions_ag_grid"
            style={{
              width: "100%",
              whiteSpace: "normal",
              wordWrap: "break-word",
              display: "flex",
            }}
          >
            <div style={{ width: "100%" }}>
              {words.length <= maxWordsToShow ? (
                <p>
                  {params.value.charAt(0).toUpperCase() + params.value.slice(1)}{" "}
                  {/* // add 'Fri Apr 19 2024' 👇 */}
                  {/* <Tooltip placement='left' title='Edit'>
                    <BiEditAlt
                      onClick={() => {
                        if (!viewOnly) {
                          setEditJobData(params.data);
                          setShowEditJobPatient(true);
                        }
                      }}
                      className='mx-2 edit_btn'
                      style={{
                        fontSize: '1.4rem',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip> */}
                </p>
              ) : (
                <p>
                  {words
                    .slice(0, maxWordsToShow)
                    .join(" ")
                    .charAt(0)
                    .toUpperCase() +
                    words.slice(0, maxWordsToShow).join(" ").slice(1)}{" "}
                  <span
                    onClick={() =>
                      openModalForTestReading(
                        "Task Details",
                        `${params.data.patientName} :: ${params.data.patientId}`,
                        params.value
                      )
                    }
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "25px",
                      fontWeight: "bold",
                    }}
                  >
                    {/* {<GrView />} */}
                  </span>
                  {/* // add 'Fri Apr 19 2024' 👇 */}
                  {/* <Tooltip placement='left' title='Edit'>
                    <BiEditAlt
                      onClick={() => {
                        if (!viewOnly) {
                          setEditJobData(params.data);
                          setShowEditJobPatient(true);
                        }
                      }}
                      className='mx-2 edit_btn'
                      style={{
                        fontSize: '1.4rem',
                        cursor: 'pointer',
                      }}
                    />
                  </Tooltip> */}
                </p>
              )}
            </div>

            <div
              style={{ width: "20%", display: "flex", flexDirection: "column" }}
            >
              {(params.data.getAllFile.length > 0 ||
                (params.data?.docFile && params.data?.pAttachmentId)) && (
                <span
                  onClick={() => {
                    viewBtnClick(params.data.getAllFile);
                    ViewAttachment(params.data.docFilePath);
                  }}
                  style={{
                    textDecoration: "underline blue",
                    cursor: "pointer",
                    fontSize: "20px",
                  }}
                >
                  <FaImages />
                </span>
              )}
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Outcome",
      field: "outComes",
      width: 470,
      maxWidth: 470,
      cellClass: "multiline-cell",
      filter: false,
      autoHeight: true,
      cellRenderer: function (params) {
        console.log('params sdsfds', params)
        // console.log(params.data.getJobListOutCome);
        const byArr1 = [...params.data.getJobListOutCome];
        const totalLetterShown = 35;
        let letterCount = 0;
        let maxWordToShow = 0;
        let wordBool = false;
        byArr1.reverse().forEach((item) => {
          const words = item.message.split(" ");
          words.forEach((word) => {
            letterCount += word.length;
            if (letterCount <= totalLetterShown) {
              maxWordToShow++;
              letterCount++;
            } else {
              wordBool = true;
              return;
            }
          });
          if (wordBool) {
            return;
          }
        });
        if (!wordBool && params?.value) {
          const words = params?.value?.split(" ");
          words.forEach((word) => {
            letterCount += word.length;
            if (letterCount < totalLetterShown) {
              maxWordToShow++;
              letterCount++;
            } else {
              wordBool = true;
              return;
            }
          });
        }
        // console.log(maxWordToShow)
        const byArr = [...params.data.getJobListOutCome];
        let arr = [];
        byArr.reverse().forEach((item) => {
          if (maxWordToShow > 0) {
            const words = item?.message?.split(" ");
            const [date, time] = item.modifiedOn.split("T");
            const [year, month, day] = date.split("-");
            const formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
            const formattedTime = time.slice(0, 5);
            if (words?.length <= maxWordToShow) {
              const obj = {
                userName: item.userName,
                formattedDate,
                formattedTime,
                message: words?.join(" "),
              };
              arr = [obj, ...arr];
            } else {
              const obj = {
                userName: item.userName,
                formattedDate,
                formattedTime,
                message: words?.slice(0, maxWordToShow)?.join(" "),
              };
              arr = [obj, ...arr];
            }
            maxWordToShow = maxWordToShow - words.length;
          }
        });
        if (
          params?.value !== "" &&
          params?.value !== null &&
          maxWordToShow > 0
        ) {
          const words = params?.value?.split(" ");
          const [date, time] = params.data.createdOn?.split("T");
          const [year, month, day] = date.split("-");
          const formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
          const formattedTime = time.slice(0, 5);
          if (words?.length <= maxWordToShow) {
            const obj = {
              userName: params.data.cUser,
              formattedDate,
              formattedTime,
              message: words?.join(" "),
            };
            arr = [obj, ...arr];
          } else {
            const obj = {
              userName: params.data.cUser,
              formattedDate,
              formattedTime,
              message: words?.slice(0, maxWordToShow)?.join(" "),
            };
            arr = [obj, ...arr];
          }
          maxWordToShow = maxWordToShow - words?.length;
        }
        const newArr = [...arr];
        // console.log("LETTER", maxWordToShow)
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              height: "100%",
              alignItems: "flex-end",
            }}
          >
            <div style={{ width: "90%" }}>
              {newArr.map((item, index) => {
                return (
                  <div
                    className="d-flex align-items-center actions_ag_grid"
                    style={{
                      width: "100%",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      display: "flex",
                    }}
                    onClick={() => {
                      if (!viewOnly) {
                        setEditJobData(params.data);
                        setShowEditJobPatient(true);
                      }
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <p>
                        {`[${item.userName?.replace(/\b\w/g, function (match) {
                          return match.toUpperCase();
                        })} ${item.formattedDate} ${item.formattedTime}]`}{" "}
                        {item.message?.charAt(0).toUpperCase() +
                          item.message?.slice(1)}{" "}
                        {index === newArr.length - 1 &&
                          maxWordToShow <= 0 &&
                          letterCount >= totalLetterShown && (
                            <span
                              onClick={() =>
                                openModalForTestReading(
                                  "Outcome",
                                  `${params.data.patientName} :: ${params.data.patientId}`,
                                  params.data
                                )
                              }
                              style={{
                                color: "blue",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "25px",
                                fontWeight: "bold",
                              }}
                            >
                              {/* {<GrView />} */}
                            </span>
                          )}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ width: "10%", marginBottom: "10px" }}>
              <Tooltip placement="left" title="Edit">
                <BiEditAlt
                  onClick={() => {
                    if (!viewOnly) {
                      setEditJobData(params.data);
                      setShowEditJobPatient(true);
                    }
                  }}
                  className="mx-2 edit_btn"
                  style={{
                    fontSize: "1.4rem",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Department",
      field: "assignedTo",
      width: 130,
      maxWidth: 130,
      filter: false,
    },
    {
      headerName: "Assigned To",
      field: "doctorId",
      width: 150,
      maxWidth: 150,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div
            className="d-flex align-items-center actions_ag_grid"
            // style={{ textTransform: 'capitalize' }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      headerName: "Due (days)",
      field: "duedate",
      width: 110,
      maxWidth: 110,
      filter: false,
      cellRenderer: function (params) {
        // const dateObject = params.value ? new Date(params.value) : null;
        // const formattedDate = dateObject && `${dateObject.getDate()}/${dateObject.getMonth() + 1}/${dateObject.getFullYear().toString().substring(2)}`;
        // console.log(params.value)
        const { daysLeft, fontColor } = calculateDaysLeft(params.value);
        console.log("fontColor", fontColor);
        return (
          <div
            className="d-flex align-items-center actions_ag_grid"
            style={{
              textTransform: "capitalize",
              color:
                params.data.status === "Completed" ? "#000" : `${fontColor}`,
            }}
          >
            {/* {formattedDate && formattedDate} */}
            {params.data.status === "Completed" ? 0 : daysLeft}
          </div>
        );
      },
    },
  ]);

  const defaultColDef = {
    filter: true,
    sortable: true,
    floatingFilter: true,
    flex: 1,
    resizable: true,
    height: 100,
    minWidth: 99,
    autoHeight: true,
    wrapText: true,
    enableColResize: true,
    autoSizeColumns: true,
  };

  function calculateDaysLeft(dueDate) {
    // Parse the due date string into a Date object
    const dueDateTime = new Date(dueDate);

    // Get the current date
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const differenceMs = dueDateTime - currentDate;

    // Convert milliseconds to days
    const differenceDays = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));

    // Set the font color based on whether the deadline is exceeded
    const fontColor = differenceDays < 0 ? "red" : "black";

    return { daysLeft: differenceDays, fontColor };
  }

  // This function will handle the API call
  const fetchFilteredData = (selectedRange, category, status, roleSelect) => {
    const startDate = moment(selectedRange[0].$d)?.format("YYYY-MM-DD");
    const endDate = moment(selectedRange[1].$d)?.format("YYYY-MM-DD");

    console.log("Fetching data with:");
    console.log("Category:", category); // Ensure correct category is sent
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    console.log("Status:", status);
    console.log("Assigned To (role):", roleSelect);

    // Trigger the API call with the filtered parameters
    Patients.getJobListForPatientByCategory(
      category,
      startDate,
      endDate,
      status,
      roleSelect,
      (response) => {
        console.log("API response:", response);
        if (
          response?.status === "success" &&
          response?.data &&
          Array?.isArray(response?.data?.jobList)
        ) {
          // const ukStartDate = moment(selectedRange[0].$d).tz("Europe/London").startOf("day");
          // const ukEndDate = moment(selectedRange[1].$d).tz("Europe/London").endOf("day");

          let newData = response.data.jobList.filter((item) => {
            const createdOn = moment(item.createdOn).format("YYYY-MM-DD");
            return createdOn >= startDate && createdOn <= endDate;
          });

          if (status) {
            newData = newData?.filter((e) => e.status === status);
          }

          setRowData(newData); // Update the rowData with the filtered data
          getJobDetailsPatient(response?.data);
        } else {
          setRowData([]); // Clear the rowData if the API response is invalid
          getJobDetailsPatient({ jobList: [], jobStatus: [] });
        }
      }
    );
  };

  // useEffect to monitor the changes in selectedRange, category, status, and assignedTo
  useEffect(() => {
    // Only call the API if all necessary parameters are available
    if (selectedRange || statusSelect || roleSelect) {
      fetchFilteredData(
        selectedRange,
        selectCategory,
        statusSelect,
        roleSelect
      );
    }
  }, [selectedRange, selectCategory, statusSelect, roleSelect]); // dependencies to trigger the effect on changes

  const filterByCategory = (value) => {
    // Update category button value
    setCategory(value);

    // // If the selected category is not 'All', trigger the API call
    // if (value !== "") {
    //   setSelectAllBtn(false);
    // } else {
    //   // If 'All' is selected, reset the button states
    //   setCategory("");
    //   setRoleSelect("");
    //   setSelectAllBtn(true);
    // }

    // Ensure 'Assigned To' (role) is only reset when a specific condition is met
    if (value === "") {
      // 'All' category selected
      setSelectAllBtn(true);

      // Preserve the role selection unless it's explicitly necessary to reset
      if (selectCategory !== "") {
        console.log("Preserving Assigned To (roleSelect):", roleSelect); // Debug
      }
    } else {
      // Specific category selected
      setSelectAllBtn(false);
    }

    const startDate = moment(selectedRange[0].$d).format("YYYY-MM-DD");
    const endDate = moment(selectedRange[1].$d).format("YYYY-MM-DD");

    console.log("Sending Start Date:", startDate);
    console.log("Sending End Date:", endDate);
    console.log("Selected Category:", value); // Log selected category
    console.log("Selected Role:", roleSelect); // Log selected role
    console.log("jobListData", jobListData);
    console.log("assignedData", assignedData);
    console.log("getRoleListStatus", getRoleListStatus);
    console.log("getCaegoryListStatus", getCaegoryListStatus);

    // Call the API every time a new category is selected
    Patients.getJobListForPatientByCategory(
      value,
      startDate,
      endDate,
      statusSelect,
      roleSelect,
      (response) => {
        console.log("API response:", response); // Inspect the full response
        if (
          response?.status === "success" &&
          response?.data &&
          Array?.isArray(response?.data?.jobList)
        ) {
          console.log("Job List Data:", response.data.jobList); // Inspect jobList data

          let newData = [];

          // Check if jobList exists and is an array
          if (Array?.isArray(response?.data?.jobList)) {
            // const ukStartDate = moment(selectedRange[0].$d)
            //   .tz("Europe/London")
            //   .startOf("day");
            // const ukEndDate = moment(selectedRange[1].$d)
            //   .tz("Europe/London")
            //   .endOf("day");

            newData = response?.data?.jobList?.filter((item) => {
              const createdOn = moment(item.createdOn).format("YYYY-MM-DD"); // Normalize createdOn to YYYY-MM-DD format
              return createdOn >= startDate && createdOn <= endDate; // Compare directly with startDate and endDate
            });

            console.log("Filtered newData:", newData);

            // Apply status filter if selected
            if (statusSelect) {
              newData = newData.filter((e) => e.status === statusSelect);
            }
          } else {
            console.error("jobList is not an array or is missing");
          }

          setRowData([...newData]); // Update state with filtered data
          getJobDetailsPatient(response?.data);
          console.log("response.data", response.data);
        } else {
          console.warn("No success status or missing data");
          setRowData([]); // Clear rowData if no success
          getJobDetailsPatient({ jobList: [], jobStatus: [] });
        }

        console.log("Final rowData:", rowData);
      }
    );
  };

  const resetAllStates = () => {
    // Reset all state variables here
    setRowData([]); // Example: Reset table data
    setCategory(""); // Reset category button
    setSelectAllBtn(false); // Reset 'All' button
    setRoleSelect(""); // Reset role select
    setStatusSelect(""); // Reset status filter
    // setJobListData([]); // Reset job list data
    // setBoxShown([]); // Reset any displayed box data
    setSelectedRange(defaultValue); // Reset date range picker
    console.log("All states have been reset!");
  };

  const filterByRole = (value) => {
    // console.log(value);
    // setSelectAllBtn(false);
    // if (value === '' || roleSelect === value) {
    //   setRoleSelect('');
    // } else {
    //   setCurrentClkBtn('role');
    //   setRoleSelect(value);
    // }
  };
  // const handleClose = () => {
  //   setImagePopUp(false);
  //   setImageLink('');
  // };

  const handleCloseReadPopup = () => {
    // setShowPopUp(false);
    // setCurrentMessage(null);
    // setCurrentObj(null);
  };

  const getRowStyle = (params) => {
    // console.log('params ----------->', params);
    const dueDate = new Date(params.data.duedate);
    const today = new Date();
    // params.data.duedate == 'Open
    if (dueDate < today && params.data.status !== "Completed") {
      return { background: "#f4bdbd", color: "black" }; // Adjust the background color as needed
    } else if (params.node.rowIndex % 2 === 0) {
      return { background: "#f2f2f2" }; // Even rows
    } else {
      return null; // Odd rows // return null; // Default style
    }
  };
  const handleAssignedTo = (val) => {
    console.log(val);
  };
  const handleCategory = (val) => {};
  return !loading1 && !loading2 && !loading3 ? (
    <div style={{ marginTop: "15px" }}>
      <Row style={{ justifyContent: "space-between" }}>
        {/* <Col style={{ display: "flex", justifyContent: "flex-end" }}> */}
        {/* <Row style={{ width: "100%", justifyContent: "flex-end" }}> */}
        <div style={{ display: "flex", paddingBottom: "15px" }}>
          <div style={{ display: "flex", alignItems: "flex-end" }}>
            <Form.Label
              className="ml-3"
              htmlFor="date"
              style={{ margin: "0px" }}
            >
              Date Range :
            </Form.Label>
          </div>
          <div>
            <Space
              direction="vertical"
              className="custom_input_clock ml-2"
              size={12}
            >
              <RangePicker
                value={selectedRange}
                onChange={handleDateChange}
                format="DD-MM-YYYY"
              />
            </Space>
          </div>
        </div>

        {/* </Row> */}
        {/* </Col> */}
        {/* <Col> */}
        <div style={{ width: "15%" }}>
          <Form.Group
            style={{
              marginBottom: "0px",
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <Form.Label style={{ width: "30%", marginBottom: "0px" }}>
              Status:
            </Form.Label>
            <Select
              defaultValue="Open"
              placeholder="Select Status"
              value={statusSelect}
              style={{
                width: 120,
              }}
              onChange={handleChange}
            >
              <Option value="">Select All</Option>
              <Option value="Open">Open</Option>
              <Option value="Completed">Completed</Option>
            </Select>
          </Form.Group>
        </div>
        {/* </Col> */}
        {/* <Col> */}
        <div style={{ width: "20%" }}>
          <Form.Group
            className="d-flex"
            style={{
              marginBottom: "0px",
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <Form.Label style={{ width: "40%", marginBottom: "0px" }}>
              Category:
            </Form.Label>
            <Select
              value={selectCategory}
              style={{
                width: "85%",
              }}
              onChange={(val) => {
                // handleCategory
                // console.log(val);
                filterByCategory(val);
                console.log("val", val);
              }}
            >
              <Option value="">All</Option>
              <Option value="Scripts">Script</Option>
              <Option value="Letters">Letter</Option>
              <Option value="Advice">Advice</Option>
              <Option value="Results">Results</Option>
              <Option value="Complaints">Complaints</Option>
            </Select>
          </Form.Group>
        </div>

        {/* </Col> */}
        {/* <Col> */}
        <div style={{ width: "20%" }}>
          <Form.Group
            className="d-flex"
            style={{
              marginBottom: "0px",
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <Form.Label style={{ width: "50%", marginBottom: "0px" }}>
              Assigned To:
            </Form.Label>
            <Select
              value={roleSelect}
              style={{
                width: "82%",
              }}
              onChange={(val) => {
                setRoleSelect(val);
                filterByRole(val);
              }}
            >
              <Option value="">Select</Option>
              <Option value="Booking Team">Booking Team</Option>
              <Option value="Clinic Team">Clinic Team</Option>
              <Option value="Admin">Admin</Option>
              <Option value="Manager">Manager</Option>
              <Option value="Doctor">Doctors</Option>
            </Select>
          </Form.Group>
        </div>

        {/* </Col> */}
        {/* <Col> */}
        <CustomButtons
          // onClick={() => window.location.reload(false)}
          onClick={resetAllStates}
          variant="primary"
          name="Refresh"
          style={{
            height: "33px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        />
        {/* </Col> */}
      </Row>

      {pdfLoading && (
        <div className="view_pdf_loading">
          <Spin size="large" className="view_pdf_loading_spin" />
        </div>
      )}
      <div
        className="ag-theme-alpine mt-2"
        style={{ height: "90vh", width: "100%" }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          animateRows={true}
          // onGridReady={onGridReady}
          pagination={true}
          paginationPageSize={50}
          debounceVerticalScrollbar={true}
          paginationAutoPageSize={true}
          getRowStyle={getRowStyle} // Set the getRowStyle callback
        />
      </div>
      <EditPatientJobDialog
        assignedData={assignedData}
        handleClose={() => setShowEditJobPatient(false)}
        showEditJobPatient={showEditJobPatient}
        editJobData={editJobData}
        getJobDetailsPatient={getJobDetailsPatient}
        getCaegoryListStatus={getCaegoryListStatus}
        getRoleListStatus={getRoleListStatus}
        setLoadingForDelete={setLoadingForDelete}
        loadingForDelete={loadingForDelete}
        roleListStatus={roleListStatus}
      />
      <Modal
        size="md"
        show={loadingForDelete}
        centered
        className="labloader_modal"
      >
        <Modal.Body>
          <div className="spinner-container">
            <div className={`loading-spinner`}></div>
          </div>
        </Modal.Body>
      </Modal>
      {currentMessage && (
        <Modal
          size="md"
          show={showPopUp}
          onHide={() => {
            handleCloseReadPopup();
          }}
          centered
          className="taskDetails_popup_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{currentMessage?.fieldName}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "10px 25px" }}>
            <>
              {currentObj && currentObj?.outcomes && (
                <p
                  style={{
                    textAlign: "justify",
                    lineHeight: "25px",
                    marginBottom: "15px",
                  }}
                >
                  {`[${currentObj.cUser?.replace(/\b\w/g, function (match) {
                    return match.toUpperCase();
                  })} ${currentObj.formattedDate} ${currentObj.formattedTime}]`}
                  <br />
                  <span>
                    {currentObj?.outcomes?.charAt(0).toUpperCase() +
                      currentObj?.outcomes?.slice(1)}
                  </span>
                </p>
              )}
              {currentObj &&
                currentObj.getJobListOutCome.map((item) => {
                  const [date, time] = item.modifiedOn.split("T");
                  const [year, month, day] = date.split("-");
                  const formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
                  const formattedTime = time.slice(0, 5);
                  return (
                    <>
                      {
                        <p
                          style={{
                            textAlign: "justify",
                            lineHeight: "25px",
                            marginBottom: "15px",
                          }}
                        >
                          {`[${item.userName.replace(/\b\w/g, function (match) {
                            return match.toUpperCase();
                          })} ${formattedDate} ${formattedTime}]`}
                          <br />
                          <span>
                            {item.message.charAt(0).toUpperCase() +
                              item.message.slice(1)}
                          </span>
                        </p>
                      }
                    </>
                  );
                })}
              {currentObj === null && (
                <p
                  style={{
                    textAlign: "justify",
                    lineHeight: "25px",
                    marginBottom: "15px",
                  }}
                >
                  {currentMessage.text.charAt(0).toUpperCase() +
                    currentMessage.text.slice(1)}
                </p>
              )}
            </>
          </Modal.Body>
        </Modal>
      )}
      {/* <Modal size="xl" show={imagePopUp} onHide={() => {
          handleClose()
        }} className="image_popup" centered >
          <Modal.Header closeButton>
            <Modal.Title>View</Modal.Title>
          </Modal.Header>
          <Modal.Body className="" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            
          </Modal.Body>
        </Modal> */}
      <Modal size="xl" show={viewPDFModal} onHide={closePDFView}>
        <Modal.Header closeButton>
          <>
            <Modal.Title>View Attachments</Modal.Title>
          </>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {imageLink.map((item) => {
            if (item.filePath.includes(".pdf")) {
              return <PDFViewer pdfUrl={item.filePath} />;
            } else {
              return (
                <div style={{ width: "max-content", height: "max-content" }}>
                  <img
                    src={item.filePath}
                    alt="image1"
                    style={{
                      minWidth: "100%",
                      height: "550px",
                      maxWidth: "1100px",
                    }}
                  />
                </div>
              );
            }
          })}
          {/* {(imageLink.includes(".pdf") ? <PDFViewer pdfUrl={imageLink} /> : <div style={{ width: "max-content", height: "max-content", }}>
              <img src={imageLink} alt="image1" style={{ width: "100%", height: "550px" }} />
            </div>)} */}
          {pdfLoading ? (
            <>
              <Spin />
            </>
          ) : (
            <>
              {console.log(pdfView)}
              {pdfView?.includes(".pdf") ? (
                <PDFViewer pdfUrl={pdfView} />
              ) : (
                <div style={{ width: "max-content", height: "max-content" }}>
                  <img
                    src={pdfView}
                    alt=" "
                    style={{ width: "100%", height: "550px" }}
                  />
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  ) : (
    <Skelton />
  );
}

export default PatientJobTable;
